// extracted by mini-css-extract-plugin
export var actions = "_4r-0";
export var actionsContainer = "_4r-6";
export var border = "_4r-1";
export var childFullHeight = "_4r-d";
export var collapse = "_4r-2";
export var content = "_4r-8";
export var contentChild = "_4r-c";
export var fullscreen = "_4r-a";
export var headerContainer = "_4r-3";
export var headerRow = "_4r-5";
export var hidePadding = "_4r-9";
export var noScrollX = "_4r-e";
export var noScrollY = "_4r-f";
export var optOutTopPadding = "_4r-b";
export var pagePadding = "_4r-7";
export var profile = "_4r-g";
export var profileContainer = "_4r-h";
export var profileImage = "_4r-i";
export var profileMain = "_4r-j";
export var profileSubtitle = "_4r-l";
export var profileTitle = "_4r-k";
export var tabsWrapper = "_4r-4";
export var title = "_4r-m";